import { Receipt } from "lucide-react";

export default function TvaPage() {
  return (
    <div style={{ fontFamily: "'Sora', sans-serif", padding: "24px" }}>
      <div
        style={{
          background: "linear-gradient(135deg, rgba(249,115,22,0.1), rgba(234,179,8,0.05))",
          border: "1px solid rgba(249,115,22,0.2)",
          borderRadius: "16px",
          padding: "24px 32px",
          marginBottom: "24px",
        }}
      >
        <h1 style={{ fontSize: "1.5rem", fontWeight: 800, color: "#1A0A00", marginBottom: "4px" }}>
          Suivi TVA
        </h1>
        <p style={{ fontSize: "0.9rem", color: "#5A4A3A", lineHeight: 1.5 }}>
          Module en cours de développement. Vous pourrez suivre votre TVA collectée, déductible et à payer.
        </p>
      </div>
      <div
        style={{
          background: "white",
          border: "1px solid #EAE0D5",
          borderRadius: "16px",
          padding: "48px 24px",
          textAlign: "center",
          color: "#9A8878",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "12px" }}>
          <Receipt size={40} strokeWidth={1.5} />
        </div>
        <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>Bientôt disponible</div>
      </div>
    </div>
  );
}
